export const isNull = (arr: any): boolean => {
    return !Array.isArray(arr)
  }
  
  export const isNotNull = (arr: any): boolean => {
    return Array.isArray(arr)
  }
  
  export const isEmpty = (arr: any): boolean => {
    return !Array.isArray(arr) || arr.length === 0
  }
  
  export const isNotEmpty = (arr: any): boolean => {
    return Array.isArray(arr) && arr.length > 0
  }
  